export * from "./lottie-template.component";
